import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageService } from '#services/message.service';
import { ComponentService } from '#services/component.service';
import { FragmentComponent } from '../fragment/fragment.component';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageComponent extends FragmentComponent implements OnInit {
  @Input() show: boolean;
  @Input() position: string;
  showPopupMessage: boolean;
  message: string;
  subscription: Subscription;
  popupSubscription: Subscription;

  constructor(
    private messageService: MessageService,
    componentService: ComponentService
  ) {
    super(componentService);
  }

  ngOnInit() {
    if (this.position === 'popup') {
      this.popupSubscription = this.messageService.showPopupMessage$.subscribe(
        status => {
          if (status) {
            this.show = true;
            this.message = this.messageService.message;
          } else {
            this.show = false;
          }
        }
      );
    } else {
      this.subscription = this.messageService.showMessage$.subscribe(status => {
        if (status) {
          this.show = true;
          this.message = this.messageService.message;
        } else {
          this.show = false;
        }
      });
    }
  }
}
